export default "__VITE_ASSET__CyXMzE55__"